<template>
  <div class="container" :style="{ height: windowHeight + 'px' }">
    <!-- <van-nav-bar title="商户绑定" left-text="" fixed placeholder /> -->
    <van-notice-bar
      scrollable
      :text="
        '今日绑定总数：' +
        todayCount +
        '，已绑定总数：' +
        bindCount +
        '，未绑定总数：' +
        unBindCount
      "
      left-icon="volume-o"
    />
    <div v-show="voucherBindShow" style="text-align: left">
      <van-card
        v-for="item in mealList"
        :key="item.id"
        style="margin: 20px 0 20px 0"
        :title="item.title"
        :thumb="item.picture"
      >
        <template #desc>
          <div class="showDetails">
            {{ item.info }}
            <div style="position: absolute; margin-top: 10px">
              <label>套餐价:{{ item.value }}元</label>
            </div>
          </div>
        </template>
        <template #num>
          <div class="showNum">
            <label>卡券总数:{{ item.totalNum }}</label
            ><br />
            <label>今日绑定数量:{{ item.todayNum }}</label>
          </div>
        </template>
        <template #footer>
          <van-button @click="mealClick(item)" size="normal"
            >绑定查询</van-button
          >
          <van-button @click="bindCard(item.id)" size="normal"
            >绑定蟹券</van-button
          >
        </template>
      </van-card>
    </div>

    <div v-show="!voucherBindShow">
      <van-tabs v-model="topActive" @change="orderTabChange">
        <van-tab name="index0" :title="'未发货（' + unDeliverTotal + '）'">
          <van-search
            v-model="undeliverSearch"
            placeholder="输入收货人或电话进行搜索"
            input-align="center"
            @search="unDeliverSearchEnvent"
          />
          <div
            style="background: white; margin: 0 0 20px 0"
            v-for="item in undeliver"
            :key="item.id"
          >
            <van-cell
              size="large"
              style="text-align: left"
              title="券卡提货"
              value="未发货"
              icon="shopping-cart-o"
              value-class="undeliverClass"
            ></van-cell>
            <van-card
              @click="showOrderDetails(item.cardNo)"
              style="margin: 0; text-align: left"
              :title="item.title"
              :thumb="item.picture"
            >
              <template #desc>
                <div class="showDetails">
                  <label>收货地址:{{ item.address }}</label>
                  <br />
                  <label>联系方式:{{ item.consignee }},{{ item.phone }}</label>
                </div>
              </template>
            </van-card>
            <van-divider :style="{ margin: '0' }" />
            <van-cell title="">
              <template #default>
                <van-button
                  size="small"
                  @click="copyAddress(item)"
                  v-clipboard:copy="copyText"
                  v-clipboard:success="onCopy"
                  >复制地址</van-button
                >&emsp;
                <van-button size="small" @click="bindOrder(item.id)"
                  >发货</van-button
                >
              </template>
            </van-cell>
          </div>
          <van-pagination
            v-model="unDeliverCurrentPage"
            v-show="unDeliverTotal != 0"
            :total-items="unDeliverTotal"
            :items-per-page="pageSize"
            @change="unDeliverPageChange"
            style="margin: 20px 0 20px 0"
          />
        </van-tab>

        <van-tab name="index1" :title="'已发货（' + deliverTotal + '）'">
          <van-search
            v-model="deliverSearch"
            placeholder="输入收货人或电话进行搜索"
            input-align="center"
            @search="deliverSearchEnvent"
          />
          <div
            style="background: white; margin: 0 0 20px 0"
            v-for="item in deliver"
            :key="item.id"
          >
            <van-cell
              size="large"
              style="text-align: left"
              title="券卡提货"
              value="已发货"
              icon="shopping-cart-o"
              value-class="deliverClass"
            ></van-cell>
            <van-card
              @click="showOrderDetails(item.cardNo)"
              style="margin: 0; text-align: left"
              :title="item.title"
              :thumb="item.picture"
            >
              <template #desc>
                <div class="showDetails">
                  <label>收货地址:{{ item.address }}</label>
                  <br />
                  <label>联系方式:{{ item.consignee }},{{ item.phone }}</label>
                  <br />
                  <label>发货时间:{{ item.delTime }}</label>
                </div>
              </template>
            </van-card>
            <van-divider :style="{ margin: '0' }" />
            <van-cell title="">
              <template #default>
                <van-button size="small" @click="showLogistics(item.expressNo)"
                  >查看物流</van-button
                >&ensp;
                <van-button size="small" @click="updateLogisticsNumber(item.id)"
                  >修改快递单号</van-button
                >
              </template>
            </van-cell>
          </div>
          <van-pagination
            v-model="dliverCurrentPage"
            v-show="deliverTotal != 0"
            :total-items="deliverTotal"
            :items-per-page="pageSize"
            style="margin: 20px 0 20px 0"
            @change="deliverPageChange"
          />
        </van-tab>
      </van-tabs>
    </div>

    <van-tabbar v-model="active" @change="onChange" placeholder>
      <van-tabbar-item icon="logistics">发货</van-tabbar-item>
      <van-tabbar-item icon="debit-pay">卡券绑定</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import api from "../../common/js/api";
export default {
  data() {
    return {
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      active: 0, //底部tabbar选中的下标索引
      voucherBindShow: false, //卡券绑定界面是否显示
      mealList: [], //套餐列表
      undeliver: [], //未发货
      deliver: [], //已发货
      openId: "",
      topActive: 0, //顶部tab index
      copyText: "",
      undeliverSearch: "",
      unDeliverCurrentPage: 1,
      deliverSearch: "",
      dliverCurrentPage: 1,
      pageSize: 4,
      unDeliverTotal: 0,
      deliverTotal: 0,
      todayCount: 0,
      bindCount: 0,
      unBindCount: 0,
    };
  },

  components: {},

  computed: {},

  created() {
    this.openId = localStorage.getItem("openId");
    // this.openId = "objUkwwenMEm4QfJcImDARnMUeP4";
  },

  mounted() {},

  activated() {
    this.getCount();
    this.getMealList();
    this.getUnDeliverList();
    this.getDeliverList();
  },

  methods: {
    getCount() {
      this.$post(api.getCount, { openId: this.openId }).then((res) => {
        if (res.success) {
          this.todayCount = res.data.todayNum;
          this.unBindCount = res.data.unBindNum;
          this.bindCount = res.data.bindNum;
        } else {
          this.$toast(res.message);
        }
      });
    },
    mealClick(item) {
      this.$router.push({
        path: "/voucherList",
        query: {
          id: item.id,
          title: item.title,
        },
      });
    },
    getMealList() {
      this.$post(api.getMealList, { openId: this.openId }).then((res) => {
        if (res.success) {
          this.mealList = res.data.list;
        } else {
          this.$toast(res.message);
        }
      });
    },
    getUnDeliverList() {
      this.$post(api.getUnDeliverList, {
        pageNum: this.unDeliverCurrentPage,
        pageSize: this.pageSize,
        openId: this.openId,
        content: this.undeliverSearch,
      }).then((res) => {
        if (res.success) {
          this.unDeliverTotal = res.data.noFaHoNum;
          this.undeliver = res.data.noFaHo.list;
        } else {
          this.$toast(res.message);
        }
      });
    },
    getDeliverList() {
      this.$post(api.getDeliverList, {
        pageNum: this.dliverCurrentPage,
        pageSize: this.pageSize,
        openId: this.openId,
        content: this.deliverSearch,
      }).then((res) => {
        if (res.success) {
          this.deliverTotal = res.data.faHoNum;
          this.deliver = res.data.faHo.list;
        } else {
          this.$toast(res.message);
        }
      });
    },
    unDeliverPageChange() {
      this.getUnDeliverList();
    },
    unDeliverSearchEnvent() {
      this.getUnDeliverList();
    },
    deliverPageChange() {
      this.getDeliverList();
    },
    deliverSearchEnvent() {
      this.getDeliverList();
    },
    onChange(index) {
      this.active = index;
      switch (index) {
        case 0:
          this.voucherBindShow = false;
          this.getUnDeliverList();
          this.getDeliverList();
          break;
        case 1:
          this.voucherBindShow = true;
          this.getMealList();
          break;
      }
    },
    orderTabChange(name) {
      if (name == "index0") {
        this.getUnDeliverList();
      } else {
        this.getDeliverList();
      }
    },
    bindCard(id) {
      // this.$router.push({
      //   path: "/scanner",
      //   query: {
      //     type: "bindMeal",
      //     id,
      //     title: "扫码绑定卡券",
      //   },
      // });
      let that = this;
      // 非微信环境 wx.scanQRCode 永远不会触发，直接提示，避免“点击没反应”
      if (!/MicroMessenger/i.test(navigator.userAgent)) {
        that.$toast("请在微信中打开此页面使用扫码功能");
        return;
      }
      wx.ready(function () {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维，默认二者都有
          success: function (res) {
            var result = that.getUrlKey(res.resultStr, "voucherCode");
            that
              .$post(api.bindCard, {
                cardNo: result.trim(),
                optionsId: id,
              })
              .then((res) => {
                if (res.success) {
                  that.$toast({ message: res.message, type: "success" });
                  that.getMealList();
                } else {
                  that.$toast(res.message);
                }
              });
          },
          fail: function (err) {
            that.$toast("扫码失败：" + (err.errMsg || JSON.stringify(err)));
          },
        });
      });
    },
    bindOrder(id) {
      // this.$router.push({
      //   path: "/scanner",
      //   query: {
      //     type: "bindOrder",
      //     id,
      //     title: "扫码发货",
      //   },
      // });
      let that = this;
      // 非微信环境 wx.scanQRCode 永远不会触发，直接提示，避免“点击没反应”
      if (!/MicroMessenger/i.test(navigator.userAgent)) {
        that.$toast("请在微信中打开此页面使用扫码功能");
        return;
      }
      wx.ready(function () {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维，默认二者都有
          success: function (res) {
            var result = res.resultStr;
            if (result.includes(",")) {
              result = result.split(",")[1];
            }
            that
              .$post(api.bindOrder, {
                openId: that.openId,
                id: id,
                expressNo: result,
              })
              .then((res) => {
                if (res.success) {
                  that.$toast({
                    message: res.message,
                    type: "success",
                  });
                  that.getUnDeliverList();
                  that.getDeliverList();
                } else {
                  that.$toast(res.message);
                }
              });
          },
          fail: function (err) {
            that.$toast("扫码失败：" + (err.errMsg || JSON.stringify(err)));
          },
        });
      });
    },
    updateLogisticsNumber(id) {
      let that = this;
      // 非微信环境 wx.scanQRCode 永远不会触发，直接提示，避免“点击没反应”
      if (!/MicroMessenger/i.test(navigator.userAgent)) {
        that.$toast("请在微信中打开此页面使用扫码功能");
        return;
      }
      wx.ready(function () {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维，默认二者都有
          success: function (res) {
            var result = res.resultStr;
            if (result.includes(",")) {
              result = result.split(",")[1];
            }
            that
              .$post(api.updateExpressNo, {
                id: id,
                expressNo: result,
              })
              .then((res) => {
                if (res.success) {
                  that.$toast({
                    message: res.message,
                    type: "success",
                  });
                  that.getUnDeliverList();
                  that.getDeliverList();
                } else {
                  that.$toast(res.message);
                }
              });
          },
          fail: function (err) {
            that.$toast("扫码失败：" + (err.errMsg || JSON.stringify(err)));
          },
        });
      });
    },
    copyAddress(item) {
      this.copyText = item.address + "  " + item.consignee + "  " + item.phone;
    },
    onCopy() {
      this.$toast("复制成功");
    },
    showLogistics(logisticsNumber) {
      window.location.href =
        "https://m.baidu.com/from=1001192y/s?word=" +
        logisticsNumber +
        "&ts=0221530&t_kt=0&ie=utf-8&fm_kl=502770f412&rsv_iqid=3932057501&rsv_t=4d0ciNbLD4%252BpAPcVhJqVth2wGGvzKgnvjBuhb5udrFkc5dG47AMaX35Ctia9ov8&sa=ib&rsv_pq=3932057501&rsv_sug4=4524&ss=110&tj=1&inputT=593&sugid=2070751438280796965";
    },
    showOrderDetails(voucherCode) {
      this.$router.push({
        path: "/orderDetails",
        query: {
          voucherCode,
          isShowReceive: false,
        },
      });
    },
    getUrlKey(url, paraName) {
      var arrObj = url.split("?");

      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");

          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.container {
  width: 100%;
  background-color: rgba(247, 243, 249, 1);
  .scanBtn {
    position: absolute;
    right: 0;
    margin: 0 20px 0 0;
  }
  .showNum {
    text-align: right;
    font-size: 13px;
    margin-bottom: 20px;
  }
  .showDetails {
    margin: 8px 0 0 0;
    color: gray;
  }
}
.deliverClass {
  color: green;
  font-size: 15px;
}
.undeliverClass {
  color: red;
  font-size: 15px;
}
.van-cell__title {
  display: contents;
}
</style>